import React from 'react';
import { Grid } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';

interface TablePaginationProps {
  tableMode: string;
  currentDataSource: any;
  onPaginate: (event: React.ChangeEvent<unknown>, value: number) => void;
}
const TablePagination = ({
  tableMode,
  currentDataSource,
  onPaginate,
}: TablePaginationProps): JSX.Element => {
  if (!currentDataSource) return <></>;
  const { total_page, page } = currentDataSource;
  return (
    <Grid
      container
      style={{
        marginTop: '2rem',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      {tableMode === 'view' ? (
        <Pagination
          data-testid="page-pagination-holder"
          count={total_page == 0 ? 1 : total_page}
          defaultPage={undefined}
          page={page == 0 ? 1 : page}
          onChange={onPaginate}
        />
      ) : null}
    </Grid>
  );
};
export default TablePagination;
